import * as React from 'react';

import { CheckboxVisibility, ConstrainMode, DetailsList, IColumn, Selection } from '@fluentui/react';

import { Partner } from '../../redux/on-site-manager/partners/types';

export interface PartnerDetailsListProps {
  partnerActiveItem: string;
  items: Partner[];
  columns: IColumn[];
  setPartnerActiveKey: (key: string) => void;
}

export interface PartnerDetailsListState {
  items?: Partner[];
}

export class PartnerDetailsList extends React.Component<PartnerDetailsListProps, PartnerDetailsListState> {
  private selection: Selection;

  constructor(props: PartnerDetailsListProps) {
    super(props);

    this.state = {
      items: props.items || [],
    };

    this.selection = new Selection({
      getKey: (data: any) => data.id,
      canSelectItem: () => true,
    });
  }

  public componentDidMount() {
    this.setItems(this.props.items);
  }

  public componentDidUpdate(prevProps: PartnerDetailsListProps) {
    if (this.props.items !== prevProps.items) {
      this.setItems(this.props.items);
    }
    if (this.props.partnerActiveItem && this.props.partnerActiveItem !== prevProps.partnerActiveItem) {
      this.selection.setKeySelected(this.props.partnerActiveItem, true, true);
    }
  }

  public render(): JSX.Element {
    const { items } = this.state;

    return (
      <DetailsList
        compact={true}
        constrainMode={ConstrainMode.horizontalConstrained}
        checkboxVisibility={CheckboxVisibility.hidden}
        items={items as any[]}
        setKey="set"
        columns={this.props.columns}
        selection={this.selection}
        onActiveItemChanged={this.onActiveItemChanged}
      />
    );
  }

  private setItems(items: Partner[]) {
    this.selection.setItems(items as any);
    this.setState({ items });
  }

  private onActiveItemChanged = (item: Partner) => {
    this.props.setPartnerActiveKey(item.id!);
  };
}
